import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, JobFile } from "@/types";

export function useDeleteJobFile() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({ jobFileId }: { jobFileId: number }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/files/${jobFileId.toString()}`;
      const res = await guacHttpClient.delete<JobFile, HttpResponse<JobFile>>(
        path,
      );

      return res.data;
    },
  });

  return mutation;
}
